import React from "react";
import { FaArrowLeft } from "react-icons/fa";

import TextComposer from "./Composer/TextComposer";
import VoiceComposer from "./Composer/VoiceComposer";
import PhotoComposer from "./Composer/PhotoComposer";
import VideoComposer from "./Composer/VideoComposer";

import { getMediaUrl } from "../lib/utils";

const Reply = ({ replyType, comment, closeReply }) => {
  if (!comment) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/35 p-3 backdrop-blur-[2px] sm:p-5">
      <div className="flex max-h-[calc(100dvh-24px)] w-full max-w-xl flex-col overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-[0_30px_90px_rgba(0,0,0,0.2)] sm:max-h-[85vh]">
        {/* HEADER */}

        <div className="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-4">
          <button type="button" onClick={closeReply} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-50 text-gray-500 transition hover:bg-gray-100 hover:text-gray-900">
            <FaArrowLeft size={14} />
          </button>

          <img src={getMediaUrl(comment?.profile_img)} alt={`${comment?.firstname || ""} ${comment?.lastname || ""}`} className="h-9 w-9 shrink-0 rounded-full object-cover" />

          <div className="min-w-0">
            <p className="text-xs text-gray-400">Replying to</p>
            <p className="truncate text-sm font-semibold text-gray-900">{comment?.firstname} {comment?.lastname}</p>
          </div>
        </div>

        {/* CONTENT */}

        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
          {replyType === "text" && <TextComposer mode="reply" type={replyType} comment={comment} closeReply={closeReply} />}
          {replyType === "voice" && <VoiceComposer mode="reply" type={replyType} comment={comment} closeReply={closeReply} />}
          {replyType === "photo" && <PhotoComposer mode="reply" type={replyType} comment={comment} closeReply={closeReply} />}
          {replyType === "video" && <VideoComposer mode="reply" type={replyType} comment={comment} closeReply={closeReply} />}
        </div>
      </div>
    </div>
  );
};

export default Reply;